import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

interface NftStats {
  id: number;
  icon: ReactNode;
  count?: number;
  action?: () => void;
}
export interface Props {
  stats: NftStats[];
}

const NftStats = ({ stats }: Props) => {
  return (
    <div className="flex items-center gap-x-4">
      {stats.map((stat) => {
        return (
          <button
            onClick={stat.action}
            className={twMerge(
              "flex items-center gap-x-2",
              !stat.action && "cursor-default",
            )}
            key={stat.id}
          >
            {stat.icon}
            {stat.count}
          </button>
        );
      })}
    </div>
  );
};

export default NftStats;
